import { FormBase } from 'core/components';

export default class PalletCreateForm extends FormBase {
	constructor(hooks) {
		super(hooks);
	}
	setup() {
		return {
			fields: [
				{
					name: 'name',
					label: 'FULFILLMENTORDER.PALLETIZINGMODE.NAME',
					rules: 'required',
				},
				{
					name: 'carrierService',
					fields: [
						{
							name: 'id',
							label: 'FULFILLMENTORDER.PALLETIZINGMODE.CARRIERSERVICE',
							rules: 'required',
						},
					],
				},
				{
					name: 'warehouse',
					fields: [
						{
							name: 'id',
							label: 'FULFILLMENTORDER.PALLETIZINGMODE.WAREHOUSE',
						},
					],
				},
			],
		};
	}
	options() {
		return { validateOnBlur: false, showErrorsOnReset: false, validateOnChange: false };
	}
}



// WEBPACK FOOTER //
// ./src/modules/order/forms/PalletCreateForm.js